<fa-icon [icon]="faCopy"></fa-icon> <ng-content></ng-content>
